import React from 'react';
import RenderRevisionNodes from '../../../Documents/components/RenderRevisionNodes';

/**
 * OriginalPreview Component
 * Shows the current state of the target document
 * Uses existing Document components for rendering
 * Data fetched from target document's revision ID using getRevAllNodes
 */
const OriginalPreview = ({ data, targetDocument }) => {
  if (!data || !targetDocument) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '40px',
        color: '#666'
      }}>
        <p>Loading original document...</p>
      </div>
    );
  }

  return (
    <div>
      {/* Use existing Document rendering components with preloaded data from target revision */}
      <RenderRevisionNodes
        partRef={targetDocument.partId}
        procedureRevRef={targetDocument.revisionId}
        partNumber={targetDocument.partNumber}
        revision={targetDocument.revision}
        disabled={true} // Read-only view
        showCheckbox={false} // Hide checkboxes in preview
        preloadedData={data} // Pass the fetched data from target revision
        forceShowChildHeadings={true}
      />
    </div>
  );
};

export default OriginalPreview;
